import {
  LocalStorageService,
  useLocalStorageJSON,
} from "../services/LocalStorage";

type AuthOverride = { url: string; token: string };

// Validate the passed AuthOverride against the current URL
export const isAuthOverrideValid = (
  authOverride: AuthOverride | undefined,
): AuthOverride | undefined => {
  if (
    authOverride &&
    authOverride.token &&
    authOverride.url &&
    window?.location.pathname.startsWith(authOverride.url)
  ) {
    return authOverride;
  }
};

// Hook which listens to localstorage for a valid auth override token
export const useAuthOverride = (): AuthOverride | undefined => {
  const authOverride = useLocalStorageJSON(
    LocalStorageService.Keys.AUTH_OVERRIDE,
  );
  if (isAuthOverrideValid(authOverride)) {
    return authOverride;
  } else if (authOverride) {
    // If the token is invalid, remove it from local storage. This should happen
    // when the authOverride token request fails for an invalid request, see
    // `regenContext.ts`, but it is possible to navigate in such a way that
    // the token isn't cleared by being logged in, using the magic url to set
    // a token, navigating around the site, returning back to this page.
    // Since the user is logged in, the loginWithRedirect() isn't triggered
    // by `regenFetcher.ts` to clear the token.
    LocalStorageService.removeItem(LocalStorageService.Keys.AUTH_OVERRIDE);
  }
};
